import React from "react";
import { Router, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "../store/store";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { history } from "../Utils/menuCoach";

import Routes from "./Routes";


function WebRoutes() {

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <GoogleOAuthProvider clientId="1099024667628-r699b92h229rkft599qiqtc5s1bo7g0d.apps.googleusercontent.com">
        <Router history={history}>
          <Switch>
            <Routes/>
          </Switch>
        </Router>
      </GoogleOAuthProvider>
        
      </PersistGate>
    </Provider>
  );
}

export default WebRoutes;
